import React__default from 'react';
import PropTypes from 'prop-types';

var PaymentAdviceRow = function PaymentAdviceRow(props) {
  var title = props.title,
    content = props.content,
    className = props.className,
    titleNotBold = props.titleNotBold;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "payment-advice-row ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "payment-advice-row-title ".concat(!titleNotBold ? 'text-bold' : '')
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "payment-advice-row-content"
  }, content));
};
PaymentAdviceRow.defaultProps = {
  className: '',
  titleNotBold: false
};
PaymentAdviceRow.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  titleNotBold: PropTypes.bool
};

export default PaymentAdviceRow;
//# sourceMappingURL=PaymentAdviceRow.js.map
